/** A readable message from whatever an auth or API call threw or returned. */
export function errorMessage(error: unknown, fallback?: string) {
	if (error instanceof Error && error.message) {
		return error.message;
	}
	if (
		error &&
		typeof error === "object" &&
		"message" in error &&
		typeof error.message === "string" &&
		error.message
	) {
		return error.message;
	}
	return fallback;
}
